import { getInstance as getBootstrap } from 'utils/bootstrap';

import {
    EMBED_TYPE_ZOOM,
    EMBED_TYPE_VIMEO,
    EMBED_TYPE_RAW,
    EMBED_TYPE_INTROVOKE,
    EMBED_TYPE_GOLDCAST,
} from 'common/constants/virtualEvent';

import { getGoldcastOptionState } from '../utils/getGoldcastOptionState';

const { virtualEventZoom, virtualEventVimeo, virtualEventIntrovoke } = getBootstrap().get('flags') || {
    virtualEventZoom: false,
    virtualEventVimeo: false,
    virtualEventIntrovoke: false,
};

export const IS_LD_GOLDCAST_ENABLED = Boolean(getBootstrap().get('isLdGoldcastEnabled'));
export const IS_GOLDCAST_BULK_UPLOAD_DISABLED =
    Boolean(getBootstrap().get('event')?.isBulkUploadUsed) && IS_LD_GOLDCAST_ENABLED;

export const EMBED_CONFIG_VERSION_1_0_0 = '1.0.0';
export const EMBED_CONFIG_VERSION_2_0_0 = '2.0.0';

export const EMBED_CONFIG_VERSION = EMBED_CONFIG_VERSION_2_0_0;

export const ALT_EMBED_CONFIG_KEY = 'altEmbedConfig';

const GOLDCAST_EMBED = { type: EMBED_TYPE_GOLDCAST, label: 'Cvent | Splash Studio' };

const embedTypes = [
    virtualEventIntrovoke && { type: EMBED_TYPE_INTROVOKE, label: 'Splash Studio' },
    virtualEventZoom && { type: EMBED_TYPE_ZOOM, label: 'Zoom' },
    virtualEventVimeo && { type: EMBED_TYPE_VIMEO, label: 'Vimeo' },
    { type: EMBED_TYPE_RAW, label: 'Custom Embed' },
].filter(Boolean);

/** Every embed type but Goldcast, whose option depends on the provisioning status (see getDisplayedEmbedTypes). */
export const EMBED_TYPES = embedTypes.map((embedType) => embedType.type);
export const EMBED_TYPES_LABELS = [GOLDCAST_EMBED, ...embedTypes].reduce(
    (prev, current) => ({ ...prev, [current.type]: current.label }),
    {},
);
export const LOCKED_ALT_EMBEDS = [EMBED_TYPE_ZOOM, EMBED_TYPE_INTROVOKE, EMBED_TYPE_GOLDCAST];

/**
 * Embed types listed in the embed dropdown, the same for the primary and alt modals (locked alt types are
 * listed but disabled). Goldcast comes first unless getGoldcastOptionState hides it.
 * The dropdown, the "more than one embed type" gate and the default embed type all read this list.
 */
export const getDisplayedEmbedTypes = (provisioningStatus) => {
    const { isHidden } = getGoldcastOptionState({ goldcastEligibility: { provisioningStatus } });

    return isHidden ? EMBED_TYPES : [EMBED_TYPE_GOLDCAST, ...EMBED_TYPES];
};
